const dailypriceConstants = {
  STATISTICS_REQUEST: 'DAILYPRICE_STATISTICS_REQUEST',
  STATISTICS_SUCCESS: 'DAILYPRICE_STATISTICS_SUCCESS',
  STATISTICS_FAILURE: 'DAILYPRICE_STATISTICS_FAILURE',

  STATISTICS_HISTORY_REQUEST: 'DAILYPRICE_STATISTICS_HISTORY_REQUEST',
  STATISTICS_HISTORY_SUCCESS: 'DAILYPRICE_STATISTICS_HISTORY_SUCCESS',
  STATISTICS_HISTORY_FAILURE: 'DAILYPRICE_STATISTICS_HISTORY_FAILURE',

  HISTOGRAM_REQUEST: 'DAILYPRICE_HISTOGRAM_REQUEST',
  HISTOGRAM_SUCCESS: 'DAILYPRICE_HISTOGRAM_SUCCESS',
  HISTOGRAM_FAILURE: 'DAILYPRICE_HISTOGRAM_FAILURE',
};

export default dailypriceConstants;
